import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import { useSelector } from 'react-redux';
import openIcon from '../../assets/openInNew.png';

export const RedirectPopup = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const themeData = useSelector(state => state.theme);
  const { privateLabelURL, privateLabelName } = themeData;

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.handleCancelIcon} open={props.open}>
     
      <Box className={classes.root}>
        <IconButton className={classes.closeIcon} onClick={() => props.handleCancelIcon()}>
          <CancelIcon />
        </IconButton>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>You are leaving {privateLabelName} website</Typography>
        </Box>
        
        <Box className={classes.cardBody2}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
             <Typography className={classes.paragraph}>You are being redirected to a third-party website that is not affiliated with {privateLabelURL} and may have different privacy, security, and data-handling practices. The third-party website’s privacy and security policies may differ from those of {privateLabelURL}. We encourage you to review the third-party’s policies before providing any personal information or using their services.</Typography>
              <Typography className={classes.paragraph}><b>By continuing to the link, you acknowledge and agree that you are leaving {privateLabelURL} website and assume all risks associated with the visit.</b></Typography>
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
         <Box className={classes.footerItem}>
            <Button
              variant='outlined'
              className={classes.btn}
              onClick={() => props.handleCancelIcon()}
            > Close</Button>
          </Box>

          <Box className={classes.footerItem}>
              <Button
                variant='contained'
                color='primary'
                className={classes.btn}
                onClick={() => props.handleClick()}
              >Proceed <img src={openIcon} className={classes.openIcon}/>
              </Button>
          </Box> 
        </Box>       
       
      </Box> 
    </Dialog>
  )
}
